import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import { c as classNames } from '../../shared/bind-a2a3a613.js';
import { interpolateWithHtml } from '../../utils/interpolateWithHtml.js';
import { jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "note": "web_ui__Note__note",
  "default": "web_ui__Note__default",
  "narrow": "web_ui__Note__narrow",
  "wide": "web_ui__Note__wide",
  "inverse": "web_ui__Note__inverse",
  "left": "web_ui__Note__left",
  "center": "web_ui__Note__center",
  "right": "web_ui__Note__right"
};

var NOTE_STYLING_VALUES = ['default', 'narrow', 'wide'];
var NOTE_ALIGNMENT_VALUES = ['left', 'center', 'right'];
/* ---------- Back-compat shim (deprecated) ---------- */
var NOTE_STYLING = {
  Default: 'default',
  Narrow: 'narrow',
  Wide: 'wide'
};
var NOTE_ALIGNMENT = {
  Left: 'left',
  Center: 'center',
  Right: 'right'
};

/* ---------- Type definitions ---------- */

var cssClasses = classNames.bind(styles);
var NoteBase = function NoteBase(_ref) {
  var text = _ref.text,
    _ref$styling = _ref.styling,
    styling = _ref$styling === void 0 ? 'default' : _ref$styling,
    _ref$alignment = _ref.alignment,
    alignment = _ref$alignment === void 0 ? 'left' : _ref$alignment,
    inverse = _ref.inverse,
    html = _ref.html,
    testId = _ref.testId;
  var noteClass = cssClasses(styles.note, styling, alignment, {
    inverse: inverse
  });
  var element = /*#__PURE__*/jsx("div", {
    className: noteClass,
    "data-testid": testId,
    children: text
  });
  if (html) return interpolateWithHtml(element);
  return element;
};

/** The public component type: a React component value that also has deprecated statics */

/** Exported component: arrow fn + statics, deprecations intact, docgen-friendly */
var Note = _Object$assign(NoteBase, {
  /** @deprecated Use string unions, e.g. styling="narrow" */
  Styling: NOTE_STYLING,
  /** @deprecated Use string unions, e.g. alignment="center" */
  Alignment: NOTE_ALIGNMENT
});

export { NOTE_ALIGNMENT, NOTE_ALIGNMENT_VALUES, NOTE_STYLING, NOTE_STYLING_VALUES, Note, Note as default };
//# sourceMappingURL=Note.js.map
